import { render, staticRenderFns } from "./notificationsAppointments.vue?vue&type=template&id=ab36db22&"
import script from "./notificationsAppointments.vue?vue&type=script&lang=js&"
export * from "./notificationsAppointments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports